import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssetListSharedState, AssetListStateService } from './asset-list-state.service';
import { ProjectService } from '../../../services/project.service';
import { Asset, DropdownController } from '../models/asset.model';

@Injectable({
  providedIn: 'root',
})
export class AssetListUiHelperService {
  constructor(
    private readonly stateService: AssetListStateService,
    private readonly router: Router,
    private readonly projectService: ProjectService
  ) {}

  public hasHiddenAssets(category: string, getGroupedAssetCallback: (category: string) => Asset[]): boolean {
    const assets: Asset[] = getGroupedAssetCallback(category);
    return assets.some((content: Asset) => content.hidden === true);
  }

  public getHiddenAssetsCount(category: string, getGroupedAssetCallback: (category: string) => Asset[]): number {
    const assets: Asset[] = getGroupedAssetCallback(category);
    return assets.filter((content: Asset) => content.hidden === true).length;
  }

  public toggleHiddenAssets(category: string): void {
    const state: AssetListSharedState = this.stateService.currentState;
    const hiddenAssetToggleState: Record<string, boolean> = { ...state.hiddenAssetToggleState };
    hiddenAssetToggleState[category] = !hiddenAssetToggleState[category];
    this.stateService.updateState({ hiddenAssetToggleState });
  }

  public getLengthLabel(val: string): string {
    if (!val) return 'N/A';

    if (val.includes(' ')) {
      return val;
    }

    const num: number = Number.parseInt(
      Array.from(val)
        .filter((ch: string) => /\d/.test(ch))
        .join(''),
      10
    );

    if (Number.isNaN(num)) return val;

    if (num <= 10) {
      return `SHORT ${val}`;
    } else if (num > 10 && num <= 30) {
      return `MEDIUM ${val}`;
    } else {
      return `LONG ${val}`;
    }
  }

  public validateUUID(id: string): boolean {
    const uuidRegex: RegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(id);
  }

  public toggleDropdown(content: { dropdownOpen: boolean }): void {
    content.dropdownOpen = !content.dropdownOpen;
  }

  public over(drop: DropdownController): void {
    drop.open();
  }

  public out(drop: DropdownController): void {
    drop.close();
  }

  public returnToProject(): void {
    this.router.navigate(['projects', this.projectService.project.id]);
  }

  public initializeBundle(bundle: any[]): (Asset & { dropdownOpen: boolean })[] {
    return bundle?.map((asset: Asset) => ({
      ...asset,
      dropdownOpen: false,
    }));
  }

  public onMilestoneSelect(milestone: any, filterAssetsCallback: () => void): void {
    this.stateService.updateState({ selectedMilestone: milestone?.timeline || null });
    filterAssetsCallback();
  }

  public filterAssets(filterCallback: (data: any) => void): void {
    const state: AssetListSharedState = this.stateService.currentState;
    filterCallback({
      isFilterVideoActive: state.isFilterVideoActive,
      isFilterStillActive: state.isFilterStillActive,
    });
  }
}
